import { Dispatch, State, TabName } from '../use_candidate_profile';
import { RightBarTabOption } from './layout_actions';

type RightBarKeys = Exclude<
  RightBarTabOption,
  'allJobsAndApplications' | 'appDetails' | 'securityScreening' | 'notes'
>;

export type StatusKeys = TabName | RightBarKeys | 'tasks' | 'agreements';

export type StatusType =
  | { type: 'uninitialized' | 'complete' | 'loading' }
  | { type: 'error'; context: any };

type StatusActionBody = StatusType & { key: StatusKeys };

export type Status = {
  [key in StatusKeys]: StatusType;
};

type SetStatusAction = {
  type: 'setStatus';
  payload: StatusActionBody;
};

export const setStatus =
  (_: State, dispatch: Dispatch) => (payload: StatusActionBody) => {
    dispatch({ type: 'setStatus', payload });
  };

export type Actions = SetStatusAction;
